export const POST_CHARGE_ORDER_RESULT = "PostChargeOrderResult";
export const WS_NOTIFICATION_SERVICE_NOT_CONFIGURED = "REACT_APP_NOTIFICATION_WS_HUB not configured";
export const SIGNAL_R_CONNECTION_ID_HEADER_NAME = "SignalR-ConnectionId";
export const GET_CONNECTION_ID_INVOKE = "GetConnectionId";
export const NOTIFICATION_SERVICE_CHARGE_ORDER_FAILURE = "notificationServiceChargeOrderFailure";
export const PUT_CHARGE_CONTACT_RESULT = "PutChargeContactResult";
export const PUT_CHARGE_VALIDITY_RESULT = "PutChargeValidityResult";
export const PUT_CHARGE_VEHICLE_RESULT = "PutChargeVehicleResult";
export const PUT_CHARGE_VEHICLE_DURING_VALIDITY_RESULT = "PutChargeVehicleDuringValidityResult";
export const GET_GOOGLE_PAY_STATUS = "GetGooglePayStatus";
